// extracted by mini-css-extract-plugin
export var banner = "_25-0";
export var icon = "_25-1";
export var message = "_25-2";